import dayjs from 'dayjs';
import { Avatar, Flex, Typography } from 'antd';
import React from 'react';

import { PersonalBroadcastsCreateContainer } from '../../personalBroadcasts/containers/PersonalBroadcastsCreateContainer';

const { Text } = Typography;

export const getColumns = () => [
    {
        title: <Text strong>Имя</Text>,
        dataIndex: 'name',
        key: 'name',
        render: (_, record) => (
            <Flex gap={4} align={'center'}>
                {record?.photoUrl && (
                    <Avatar
                        src={
                            record.photoUrl ? record.photoUrl : record?.name[0]
                        }
                    />
                )}
                {record?.name}
            </Flex>
        ),
    },
    {
        title: <Text strong>ID Telegram</Text>,
        dataIndex: 'telegramUserId',
        key: 'telegramUserId',
    },
    {
        title: <Text strong>Юзернэйм</Text>,
        dataIndex: 'telegramUsername',
        key: 'telegramUsername',
        render: (_, record) => (record?.username ? `${record?.username}` : ''),
    },
    {
        title: <Text strong>Телефон</Text>,
        dataIndex: 'phone',
        key: 'phone',
    },
    {
        title: <Text strong>Дата последнего посещения</Text>,
        dataIndex: 'authDate',
        key: 'authDate',
        render: time => {
            if (!time) return '-';
            const date = dayjs(time);
            return date.isValid() ? date.format('DD.MM.YY HH:mm') : '-';
        },
    },
    {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (_, record) => (
            <PersonalBroadcastsCreateContainer item={record} />
        ),
    },
];
